import { AdjustedLine, ModifierContext } from "../../modifier-models";
import { BaseRule } from "../../rule-base";

export class RulePhysio0013 extends BaseRule {
    name = 'Physio 0013: Travelling costs for distances over 16km';

    run(line: AdjustedLine, ctx: ModifierContext, autoApply: boolean): void {
        if (line.code !== '0013') return;

        if (autoApply) {
            // Travelling costs according to AA-rate for distances over 16km
            // Note: Only some medical schemes cover transport expenses, others only in exceptional cases
            // This should be calculated based on actual distance and AA rates
            const travelFee = 150; // Standard travel fee in Rands (should be calculated based on distance)
            line.adjustedUnits = 1; // One travel charge
            if (line.adjustedRand) {
                line.adjustedRand = travelFee;
            }
            line.trace.push('Physio 0013: Travelling costs applied (AA-rate for distances over 16km)');
        } else {
            line.suggestions = line.suggestions || [];
            line.suggestions.push({
                ruleCode: '0013',
                message: 'Travelling costs (over 16 km total) according to AA-rate. Note: Only some medical schemes cover transport expenses.',
                kind: 'overwrite',
                unitsDelta: 1
            });
        }
    }

    apply(lines: AdjustedLine[], ctx: ModifierContext, warn: string[]): AdjustedLine[] {
        lines.forEach(line => {
            if (line.code === '0013') {
                const travelFee = 150; // Standard travel fee in Rands
                line.adjustedUnits = 1;
                if (line.adjustedRand) {
                    line.adjustedRand = travelFee;
                }
                line.trace.push('Physio 0013: Travelling costs applied (AA-rate for distances over 16km)');
            }
        });
        return lines;
    }
} 